import { render, staticRenderFns } from "./LogoutLink.vue?vue&type=template&id=18d9f5eb"
import script from "./LogoutLink.vue?vue&type=script&lang=js"
export * from "./LogoutLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports